import React, { useCallback } from "react";
import LogDisplay from "components/Interactions/LogDisplay";
import { courseLogAPI } from "api/Interactions/CoursesAPI";
import { Column } from "components/Data/DataDisplays/GenericTable";

interface CoursesBottomDrawerProps {
  courseId: number;
}

const CoursesBottomDrawer: React.FC<CoursesBottomDrawerProps> = ({ courseId }) => {
  const fetchLogs = useCallback(() => courseLogAPI.getAllByParentId(courseId), [courseId]);

  const columns: Column<any>[] = [
    { field: "timestamp", label: "Timestamp" },
    { field: "firstName", label: "First Name" },
    { field: "lastName", label: "Last Name" },
    { field: "course_name", label: "Course Name" },
    { field: "session_name", label: "Session Name" },
  ];

  return (
    <LogDisplay
      fetchLogs={fetchLogs}
      columns={columns}
      title="Course Logs"
    />
  );
};

export default CoursesBottomDrawer;
